//importing core-js polyfills individually to reduce bundle size
//we could just swap to importing all of core-js and get every single polyfill...
import "core-js";
import "react-dates/initialize";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "mobxConfigurator";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./index.scss";
import "./assets/themes/cs.legacy/theme.css";

import React from "react";
import ReactDOM from "react-dom";
import { App } from "App";
import { AppSettingsPage } from "./pages/SystemSettings/AppSettings/AppSettingsPage";
import { RuleSettingsPage } from "./pages/SystemSettings/Rules/RuleSettingsPage";
import CaseEventCategoriesPage from "./pages/SystemSettings/CaseEventCategories/CaseEventCategoriesPage";
import DefaultEventTextPage from "pages/SystemSettings/DefaultEventText/DefaultEventTextPage";
import RequestLedgerSubCategoriesPage from "pages/SystemSettings/RequestLedgerSubCategoriesPage/RequestLedgerSubCategoriesPage";
import {
  TaxClaimEditPage,
  Props as TaxClaimEditPageProps,
} from "./pages/TaxClaim/TaxClaimEditPage";
import {
  LackOfProsecutionEditPage,
  Props as LackOfProsecutionProps,
} from "pages/LackOfProsecution/LackOfProsecutionEditPage";
import {
  LackOfProsecutionEditTemplatePage,
  Props as LackOfProsecutionEditTemplateProps,
} from "pages/LackOfProsecution/EditTemplatePage/LackOfProsecutionEditTemplatePage";
import { JudgmentsIntegrationPageViewModel } from "./pages/JudgmentsIntegration/types/JudgmentIntegrationTypes";
import { JudgmentIntegrationsPage } from "./pages/JudgmentsIntegration/JudgmentsIntegrationPage";
import {
  NotificationsPage,
  NotificationsStoreProvider,
} from "pages/Notifications";
import { EFilingCompareModal } from "./pages/eFiling/EFilingCompareModal"
import { NotificationPageViewModel } from "api";
import { EFilingCompareModalModel } from "pages/eFiling/types/EFilingCompareModalModel";
import { MailerModal } from "./pages/Case/MailerModal";
import { MailerModalModel } from "./pages/Case/types/MailerModalModel";

let Frontend: any = {};

/** system settings */
Frontend.AppSettingsPage = function (targetElement: HTMLElement) {
  ReactDOM.render(
    <App>
      <AppSettingsPage />
    </App>,
    targetElement
  );
};
Frontend.RuleSettingsPage = function (targetElement: HTMLElement) {
  ReactDOM.render(
    <App>
      <RuleSettingsPage />
    </App>,
    targetElement
  );
};
Frontend.CaseEventCategoriesPage = function (targetElement: HTMLElement) {
  ReactDOM.render(
    <App>
      <CaseEventCategoriesPage />
    </App>,
    targetElement
  );
};
Frontend.DefaultEventTextPage = function (targetElement: HTMLElement) {
  ReactDOM.render(
    <App>
      <DefaultEventTextPage />
    </App>,
    targetElement
  );
};
Frontend.RequestLedgerSubCategoriesPage = function (
  targetElement: HTMLElement
) {
  ReactDOM.render(
    <App>
      <RequestLedgerSubCategoriesPage />
    </App>,
    targetElement
  );
};

/**tax claim */
Frontend.TaxClaimEditPage = function (
  targetElement: HTMLElement,
  initialProps: TaxClaimEditPageProps
) {
  ReactDOM.render(<TaxClaimEditPage {...initialProps} />, targetElement);
};

/**lack of prosecution */
Frontend.LackOfProsecutionEditPage = function (
  targetElement: HTMLElement,
  initialProps: LackOfProsecutionProps
) {
  ReactDOM.render(
    <LackOfProsecutionEditPage {...initialProps} />,
    targetElement
  );
};
Frontend.LackOfProsecutionEditTemplatePage = function (
  targetElement: HTMLElement,
  initialProps: LackOfProsecutionEditTemplateProps
) {
  ReactDOM.render(
    <LackOfProsecutionEditTemplatePage {...initialProps} />,
    targetElement
  );
};

/* judgment integation*/
Frontend.JudgmentsIntegrationPage = function (
  targetElement: HTMLElement,
  initialProps: JudgmentsIntegrationPageViewModel
) {
  ReactDOM.render(
    <JudgmentIntegrationsPage {...initialProps} />,
    targetElement
  );
};

/* judgment integation*/
Frontend.EFilingCompareModal = function (
  targetElement: HTMLElement,
  initialProps: EFilingCompareModalModel
) {
  ReactDOM.render(
    <EFilingCompareModal {...initialProps} />,
    targetElement
  );
};

/* Case Details */
Frontend.MailerModal = function (
    targetElement: HTMLElement,
    initialProps: MailerModalModel
) {
    ReactDOM.render(
        <MailerModal {...initialProps} />,
        targetElement
    );
};

/* Notifications */
Frontend.GlobalNotificationsPage = function (
  targetElement: HTMLElement,
  initialProps: NotificationPageViewModel
) {
  ReactDOM.render(
    <NotificationsStoreProvider>
      <NotificationsPage {...initialProps} />
    </NotificationsStoreProvider>,
    targetElement
  );
};

//put Frontend on window so that MVC/WebForms has access to it
window.Frontend = Frontend;
